import { db } from "../../shared/config";
import {
  collection,
  addDoc,
  getDocs,
  getDoc,
  doc,
  updateDoc,
  deleteDoc,
  query,
  orderBy,
  startAfter,
  endBefore,
  limitToLast,
  limit,
  Timestamp,
  where,
} from "firebase/firestore";
import {
  GET_MOBILEBANNERS,
  ADD_MOBILEBANNER,
  GET_MOBILEBANNER,
  RESET_MOBILEBANNER,
  MOBILEBANNERS_ERROR,
} from "../types/mobilebanner_type";

import { setAlert } from "./alert";
import { LIMIT } from "../../domain/constant";
//GET MOBILEBANNERS
const mobilebannersRef = collection(db, "mobilebanners");
export const getMobilebanners =
  ({ term, termField, orderValue = "createdAt", orderType = "desc" }) =>
  async (dispatch) => {
    try {
      let searchQuery = null;
      if (term) {
        searchQuery = query(mobilebannersRef, where(termField, "==", term));
      } else {
        searchQuery = query(
          mobilebannersRef,
          orderBy(orderValue, orderType),
          limit(LIMIT)
        );
      }
      const querySnapshot = await getDocs(searchQuery);
      const data = [];
      querySnapshot.forEach((doc) => {
        data.push({ id: doc.id, ...doc.data() });
      });
      dispatch({
        type: GET_MOBILEBANNERS,
        payload: data,
      });
    } catch (err) {
      console.log(err);
      dispatch(setAlert("Something went wrong", "danger"));
      dispatch({
        type: MOBILEBANNERS_ERROR,
      });
    }
  };

export const getNextMobilebanners =
  ({ term, termField, last, orderValue = "createdAt", orderType = "desc" }) =>
  async (dispatch) => {
    try {
      let searchQuery = null;
      if (term) {
        searchQuery = query(
          mobilebannersRef,
          orderBy(orderValue, orderType),
          startAfter(last[orderValue]),
          limit(LIMIT),
          where(termField, "==", term)
        );
      } else {
        searchQuery = query(
          mobilebannersRef,
          orderBy(orderValue, orderType),
          startAfter(last[orderValue]),
          limit(LIMIT)
        );
      }
      const querySnapshot = await getDocs(searchQuery);
      const data = [];
      querySnapshot.forEach((doc) => {
        data.push({ id: doc.id, ...doc.data() });
      });
      dispatch({
        type: GET_MOBILEBANNERS,
        payload: data,
      });
    } catch (err) {
      console.log(err);
      dispatch(setAlert("Something went wrong", "danger"));
      dispatch({
        type: MOBILEBANNERS_ERROR,
      });
    }
  };
export const getPreviousMobilebanners =
  ({ term, termField, first, orderValue = "createdAt", orderType = "desc" }) =>
  async (dispatch) => {
    try {
      let searchQuery = null;
      if (term) {
        searchQuery = query(
          mobilebannersRef,
          orderBy(orderValue, orderType),
          endBefore(first[orderValue]),
          limitToLast(LIMIT),
          where(termField, "==", term)
        );
      } else {
        searchQuery = query(
          mobilebannersRef,
          orderBy(orderValue, orderType),
          endBefore(first[orderValue]),
          limitToLast(LIMIT)
        );
      }

      const querySnapshot = await getDocs(searchQuery);
      const data = [];
      querySnapshot.forEach((doc) => {
        data.push({ id: doc.id, ...doc.data() });
      });
      dispatch({
        type: GET_MOBILEBANNERS,
        payload: data,
      });
    } catch (err) {
      console.log(err);
      dispatch(setAlert("Something went wrong", "danger"));
      dispatch({
        type: MOBILEBANNERS_ERROR,
      });
    }
  };

export const addMobilebanner = (data) => async (dispatch) => {
  try {
    data.createdAt = Timestamp.fromDate(new Date());
    const docRef = await addDoc(mobilebannersRef, data);
    dispatch({
      type: ADD_MOBILEBANNER,
    });
    dispatch(setAlert("Mobilebanner added successfully", "success"));
  } catch (e) {
    console.error("Error adding document: ", e);
    dispatch(setAlert("Something went wrong", "danger"));
    dispatch({
      type: MOBILEBANNERS_ERROR,
    });
  }
};

export const getMobilebanner = (id) => async (dispatch) => {
  try {
    dispatch({
      type: RESET_MOBILEBANNER,
    });
    const docRef = doc(db, "mobilebanners", id);
    const docSnap = await getDoc(docRef);
    if (docSnap.exists()) {
      const data = docSnap.data();
      data.id = id;
      dispatch({
        type: GET_MOBILEBANNER,
        payload: data,
      });
    } else {
      dispatch(setAlert("Something went wrong", "danger"));
      dispatch({
        type: MOBILEBANNERS_ERROR,
      });
    }
  } catch (err) {
    dispatch(setAlert("Something went wrong", "danger"));
    dispatch({
      type: MOBILEBANNERS_ERROR,
    });
  }
};
export const editMobilebanner = (id, data) => async (dispatch) => {
  try {
    const docSnap = await updateDoc(doc(db, "mobilebanners", id), data);
    dispatch(setAlert("Mobilebanner updated successfully", "success"));
  } catch (err) {
    dispatch(setAlert("Something went wrong", "danger"));
    dispatch({
      type: MOBILEBANNERS_ERROR,
    });
  }
};

export const deleteMobilebanner = (id) => async (dispatch) => {
  try {
    const docSnap = await deleteDoc(doc(db, "mobilebanners", id));
    dispatch(setAlert("Mobilebanner deleted successfully", "success"));
  } catch (err) {
    dispatch(setAlert("Something went wrong", "danger"));
    dispatch({
      type: MOBILEBANNERS_ERROR,
    });
  }
};
